import { useMenu } from '../menuController';

/**
 * Aside del template twoColumns. Breakpoints: 0,1,2.
 *
 * Este aside aparece por defecto en la vista móvil del
 * twoColumns.
 */

export const BodyAside = () => {
  const children = useMenu([1, 2, 3]);
  return children;
};
